import { Component, Input } from '@angular/core';
import type { SupplyAddress } from '@essent/new-customer';
import type { InstallationAddress } from '@essent/installation-address';
import {
  DefaultComponentModule,
  DefaultFormComponentModule,
} from '@innogy/core/modules/components';
import { CSMaskDirective } from '@legacy/utils-contentsquare';

@Component({
  selector: 'wl-supply-address',
  templateUrl: './supply-address.component.html',
  styleUrls: [],
  standalone: true,
  imports: [
    DefaultComponentModule,
    DefaultFormComponentModule,
    CSMaskDirective,
  ],
})
export class SupplyAddressComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() supplyAddress?: Partial<SupplyAddress> | InstallationAddress;
}
